<template>
	<el-dialog
	  title="上传文件"
	  class="newDialog"
	  append-to-body
	  :close-on-click-modal="false"
	  :visible.sync="dialogVisible"
	  width="900px"
	  >
	   <div class="AI_import" v-loading="gobleLoading">
	  		<div class="AI_import-step1">
	  			<div class="AI_import-step1-title">
	  				第一步：设置导入数据编码规则
	  			</div>
	  			<div class="AI_import-step1-level">
	  				<span class="AI_import-step1-level-l">编码等级</span>
	  				<el-select v-model="formData.subjectLevel"  size="small" style='width: 60px;' @change='handleSelectChange'>
						<el-option v-for='item in subjectLevel' :lable="item.level" :value="item.level" :key='item.level' :disabled="!item.use"></el-option>
					</el-select>
	  				<p  class="AI_import-step1-level-tip">科目编码会按照 <span>（示例：1001-001-01-01）</span> 格式长度识别科目等级</p>
	  			</div>
	  			<div class="AI_import-step1-codeLength">
	  				<div class="AI_import-step1-codeLength-container">
	  					<span class="AI_import-step1-codeLength-l">编码长度</span>
			  			<el-select
			  				size="small"
			  				style='width: 60px;padding-right: 10px;'
			  				v-for='(item,index) in formData.subjectLevel'
			  				:key='item' :disabled='item==1'
			  				v-model="formData.codeLongs[item-1]"
			  				@change='handleSelectChanges(index,formData.codeLongs[item-1])'
			  			>
							<el-option
								v-for='i in options'
								:lable="i"
								:value="i"
								:key='i'>

							</el-option>
						</el-select>
	  				</div>
	  				<p  class="AI_import-step1-codeLength-tip">
	  				     科目级次和长度调大后，不能再恢复到调整前的级次和长度，请谨慎操作！
	  				</p>
	  				<p  class="AI_import-step1-codeLength-tip">
	  				     如不满足编码规则，请先调整后再上传；或将科目导入系统后，在【设置-科目】中批量调整科目等级
	  				</p>
	  			</div>
	  		</div>
	  		<div class="AI_import-step2">
	  			<div class="AI_import-step2-title">
	  				第二步：上传文件
	  			</div>
	  			<div class="AI_import-step2-import" >
	  				<el-upload
					  class="AI_upload"
					  :before-upload="beforeUpload"
					  drag
            :on-change="onChange"
					  :file-list="fileList"
					  :http-request="httpRequest"
					  action=""
            ref="AI_uploadRef"
					  multiple>
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">
					  	<p class="el-upload__text-p1">点击或将文件拖拽到这里上传</p>
					  	<p class="el-upload__text-p2">只支持上传.xls/.xlsx文件，且不能超过5M。</p>
					  </div>
					</el-upload>
	  			</div>
	  		</div>
	  		<div class="AI_import-operation">
	  			<acc-btn text="取消" type="2" @click="dialogVisible=false"></acc-btn>
	  			<acc-btn @click="handleEventSave"></acc-btn>
	  		</div>
	  </div>
	 </el-dialog>
</template>
<script>
	export default {
		data() {
			return {
				gobleLoading:false,
				formFileData:new FormData(),
				formData:{
					subjectLevel:"",
					codeLongs:[], // 科目编码长度
				},
				subjectLevel:[],
				updateVal:[],
        dialogVisible:false,
        options: [1,2,3,4],
        fileList:[]
			}
		},
		created() {
		},
		watch:{
			dialogVisible(val) {
				if(val) {
					this.getSystemSeting();
          this.getSubjectSelect();
				}else {
          this.$nextTick(()=>{
            this.formFileData = new FormData();
            this.$refs.AI_uploadRef.clearFiles();
          })
        }
			}
		},
		methods:{
      // 上传超出显示最后一个
      onChange(files, fileList) {
        if (fileList.length > 0) {
          this.fileList = [fileList[fileList.length - 1]]//这一步，是 展示最后一次选择文件
        }
      },
      // 获取科目等级
      getSubjectSelect() {
        this.subjectLevel = [];
        this.$http.post('import/getSubjectLevel',{}).then(res=>{
        	if(res&&res.data.code=="1") {
            this.subjectLevel = res.data.data;
        	}
        })
      },
			// 保存科目编码
			handleEventSave() {
				const _ = this;
				let fileData = _.formFileData.get("multipartFile");
				if(!fileData) return this.$message.warning("未检测到上传文件！")
				let params={
					level:_.formData.subjectLevel,
					codeLongs:_.formData.codeLongs.toString(),
					defaultDisplay:_.formData.defaultDisplay,
					isCheck:_.formData.toExamine,
					bookName:_.formData.bookName
				};
				_.gobleLoading = true;
				_.$http.post('createAccountSet/settingUpdate',params).then(res=>{

					if(res&&res.data.code=="1") {
						this.handleSaveFile();
					}else {
             _.formFileData = new FormData();
            _.gobleLoading = false;
          }
				})
			},
			// 上传文件保存
			handleSaveFile() {
				const _ = this;
				try {
		          const instance = this.$http.create({
		            withCredentials: true
		          })

		          instance.post(this.$rootUrl + 'import/importFileUploadSubjectFile', this.formFileData).then(res=>{
		          	_.gobleLoading = false;

		            if(res && res.data.code == 1) {
		             	_.dialogVisible = false;
		             	_.$message.success("上传成功！");
                  _.$emit("uploadSuccess",true)
		            }else {
                  _.formFileData = new FormData();
		            	_.$message.error(res.data.msg);
		            }
		          })
		         }catch(e) {

		         }
			},
			// 上传保存
			httpRequest(data) {
        this.formFileData = new FormData;
				this.formFileData.append("multipartFile",data.file);
				this.formFileData.append('cid',sessionStorage.getItem('cid'));
        		this.formFileData.append('token',sessionStorage.getItem('token'));
			},
			// 上传之前验证
			beforeUpload(file) {
				let footerName = this.getFileType(file.name);
        let isSizeBig = file.size/1024/1024 > 5;
        if(isSizeBig) {
          this.$message.warning("上传文件过大，应小于5M！");
          return false;
        }
				if(footerName!=="xls" && footerName!=="xlsx") {
					this.$message.warning("上传格式不正确！")
					return false;
				}
			},
			// 获取文件后缀
			getFileType(filePath){
				var startIndex = filePath.lastIndexOf(".");
				if(startIndex != -1)
					return filePath.substring(startIndex+1, filePath.length).toLowerCase();
				else return "";
			},
			// 获取科目编码层级
			// getSubjectLevel(){
			// 	const _ = this;
			// 	_.$http.post('sys/dict/list' ,{type:'subject_level'}).then(res=>{
			// 		if(res&&res.data.code=="1") {
			// 			_.subjectLevel = res.data.data.map(item=>{
			// 				item.value = Number(item.value);
			// 				return item;
			// 			});
			// 		}
			// 	})
			// },
			// 获取系统设置
			getSystemSeting() {
				const _ = this;
				_.$http.post('createAccountSet/getSystemSetting',{}).then(res=>{
					if(res&&res.data.code=="1") {
						_.formData = Object.assign({},_.formData,res.data.data);
						_.formData.subjectLevel = _.formData.codeLongs.length;
						_.updateVal = JSON.parse(JSON.stringify(_.formData.codeLongs));
					}
				})
			},
			// 科目编码长度改变
			handleSelectChanges(index,val) {
				const _=this;
				let params={
					level:index+1,
					codeLong:val
				};
				let updateVal = _.updateVal[index];
				_.$http.post('createAccountSet/changCodeLong' ,params).then(res=>{
					if(res&&res.data.code=="1") {
						this.updateVal = JSON.parse(JSON.stringify(this.formData.codeLongs));
					}else {
						_.formData.codeLongs.splice(index,1,updateVal)
					}
				})
			},
			// 获取科目编码层级参数改变
			handleSelectChange(val){
				let back = this.formData.codeLongs.length;
				let dataNum = this.formData.subjectLevel-back;
				if(dataNum>=0){
					for(let i=0;i<dataNum;i++){
						this.formData.codeLongs.push(2);
					}
				}else {
					this.formData.codeLongs.splice(dataNum)
				}

				this.updateVal = JSON.parse(JSON.stringify(this.formData.codeLongs));
			},
		}
	}
</script>
<style lang="less">
	.AI_import {
		padding: 0 70px 40px;
		.AI_upload {
			.el-icon-upload {
				color: #108EE9;
			}
			.el-upload__text {
				&-p1 {
					color: #666666;
				}
				&-p2 {
					color: #999999;
					margin-top: 5px;
					font-size: 12px;
				}
			}
		}
		&-operation {
			margin-top: 40px;
			text-align: center;
		}
		&-step2 {
			margin-top: 50px;
      min-height: 300px;
			&-import {
				margin-top: 28px;
			}
			&-title {
				font-size: 16px;
				font-weight: 600;
				color: #4A4A4A;
			}
		}
		&-step1 {
			&-codeLength {
				margin-top: 40px;
				margin-left: 47px;
				&-container {
					display: flex;
					align-items: center;
				}
				&-l {
					color: #4A4A4A;
					margin-right: 15px;
				}
				&-tip {
					margin-top: 10px;
					color: #9B9B9B;
					font-size: 12px;
				}
			}
			&-level {
				display: flex;
				align-items: center;
				margin-top: 40px;
				margin-left: 47px;
				&-l {
					color: #4A4A4A;
					margin-right: 15px;
				}
				&-tip {
					margin-left: 27px;
					color: #9B9B9B;
					font-size: 12px;
					span {
						color: #666;
					}
				}
			}
			&-title {
				font-size: 16px;
				font-weight: 600;
				color: #4A4A4A;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AIImport/importFile.vue